export function chatReducer (messages, action) {
    switch (action.type) {
      case 'MessageAdded': {
        return [
          ...messages,
          action.message
        ]
      }
      case 'Reacted': {
        const message = messages[action.index]
        message.reaction = action.reaction
        messages.splice(action.index, 1, message)
        return [...messages]
      }
      case 'SetMessages': {
        if (action.newChat) {
          return action.messages
        } else {
          return [...action.messages, ...messages]
        }
      }
  
      default: {
        throw Error('Unknown action: ' + action.type)
      }
    }
  }
  